import {APIRequest} from "../APIRequest.js";

export const API_URL = "https://w5ohem3kwtzzg4tfizbybtui7y0gwqxr.lambda-url.us-east-1.on.aws/";

const timeout = 10000;


export const createStripeCheckout = async (depositAmount) => {
    const token = localStorage.getItem("clientJWT");

    const queryParams = new URLSearchParams(window.location.search);
    const fullApiUrl = `${API_URL}?${queryParams.toString()}`;

    try {
        const response = await APIRequest('post', fullApiUrl, {
            token,
            amountInCents: Math.round(depositAmount * 100)
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const refund = async (paymentIntentId, reason, customerReason) => {
    const token = localStorage.getItem("clientJWT");

    const queryParams = new URLSearchParams(window.location.search);
    const fullApiUrl = `${API_URL}?${queryParams.toString()}`;

    try {
        const response = await APIRequest('post', fullApiUrl, {
            action: 'refund',
            token,
            paymentIntentId,
            customerReason,
            reason
        }, {timeout});

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

